export default function validationLength(value){
    return (value.length > 0)
}